import sliceCreator from '../../index.jsx';
import {GET_ALL_ZONES} from '../../../constants/index.jsx';
const _getAllZonesAction = sliceCreator('GET_ALL_ZONES', GET_ALL_ZONES, 'get');

const { asyncAction: getAllZonesAction, reducer, clearData: clearGetAllZonesAction } = _getAllZonesAction;

export default reducer;

export {
    getAllZonesAction,
    clearGetAllZonesAction
}